import { BiClinic, BiSolidBath, BiSolidCarGarage } from 'react-icons/bi';
import { BsBatteryCharging } from 'react-icons/bs';
import { FaFootballBall, FaHotTub, FaParking, FaPiggyBank, FaSolarPanel } from 'react-icons/fa';
import { FaPeopleRoof } from 'react-icons/fa6';
import {
  GiCampfire,
  GiFireplace,
  GiHanger,
  GiStoneWall,
  GiWaterRecycling,
  GiHotSurface,
} from 'react-icons/gi';
import { GoLaw } from 'react-icons/go';
import {
  MdElevator,
  MdBalcony,
  MdNaturePeople,
  MdCleaningServices,
  MdWaves,
  MdWifi,
  MdPool,
  MdCommute,
  MdYard,
  MdChildFriendly,
  MdRoofing,
  MdLandscape,
} from 'react-icons/md';
import {
  PiCastleTurretFill,
  PiMountainsFill,
  PiShootingStar,
  PiTreeFill,
  PiWineFill,
} from 'react-icons/pi';
import { RiSailboatFill } from 'react-icons/ri';
import { TbDental, TbMassage, TbMountain } from 'react-icons/tb';
import { FeatureType, PersonaType } from '@habity/types';
import {
  FaBabyCarriage,
  FaBeer,
  FaChild,
  FaChurch,
  FaClinicMedical,
  FaEye,
  FaRunning,
  FaShoppingBasket,
  FaShoppingCart,
  FaSpa,
  FaSubway,
} from 'react-icons/fa';
import { GiKnifeFork, GiOpenBook, GiSlicedBread } from 'react-icons/gi';
import { HiScissors } from 'react-icons/hi';
import { IoSchool } from 'react-icons/io5';
import { CgGym } from 'react-icons/cg';
import {
  MdCoffee,
  MdDryCleaning,
  MdFastfood,
  MdGolfCourse,
  MdPark,
  MdSailing,
  MdSportsBasketball,
  MdSportsTennis,
} from 'react-icons/md';
import { NearbyType, TODO } from '@habity/types';
import { IoMdBoat } from 'react-icons/io';
import { BiWater } from 'react-icons/bi';
import { BsNewspaper } from 'react-icons/bs';
import { TbCheese, TbSwimming } from 'react-icons/tb';
import { RiSchoolFill } from 'react-icons/ri';
import { FaShop } from 'react-icons/fa6';
import { GiAges, GiLovers, GiPartyHat } from 'react-icons/gi';
import { ImUser } from 'react-icons/im';
import { MdElderly, MdOutlineFamilyRestroom } from 'react-icons/md';
import { PiStudentFill } from 'react-icons/pi';
import { PersonaButtonType } from '@habity/types';

export const getFeatureButtonIcon = (key: FeatureType) => {
  switch (key) {
    case 'new_construction':
      return GiStoneWall;
    case 'pool':
      return MdPool;
    case 'lake_view':
      return MdWaves;
    case 'sea_view':
      return MdWaves;
    case 'near_lake':
      return BiWater;
    case 'near_sea':
      return BiWater;
    case 'near_beach':
      return MdSailing;
    case 'rustic':
      return PiCastleTurretFill;
    case 'geothermal_heating':
      return PiMountainsFill;
    case 'airwater_heating':
      return GiWaterRecycling;
    case 'ev_charging_post':
      return BsBatteryCharging;
    case 'balcony':
      return MdBalcony;
    case 'elevator':
      return MdElevator;
    case 'garage':
      return BiSolidCarGarage;
    case 'bath_tub':
      return BiSolidBath;
    case 'walk_in_closet':
      return GiHanger;
    case 'high_speed_internet':
      return MdWifi;
    case 'renovated':
      return MdCleaningServices;
    case 'patio':
      return MdNaturePeople;
    case 'low_loan_to_value_ratio':
      return FaPiggyBank;
    case 'low_monthly_fee':
      return FaPiggyBank;
    case 'debt_free_association':
      return FaPiggyBank;
    case 'legal_person_allowed':
      return GoLaw;
    case 'parking':
      return FaParking;
    case 'fruit_trees':
      return PiTreeFill;
    case 'jacuzzi':
      return FaHotTub;
    case 'floor_heating':
      return GiHotSurface;
    case 'mountain_view':
      return TbMountain;
    case 'child_friendly_area':
      return MdChildFriendly;
    case 'golf_course':
      return MdGolfCourse;
    case 'solar_panels':
      return FaSolarPanel;
    case 'boat_berth':
      return RiSailboatFill;
    case 'potential_for_pool':
      return MdPool;
    case 'fireplace':
      return GiFireplace;
    case 'terrace':
      return MdNaturePeople;
    case 'reputed_area':
      return PiShootingStar;
    case 'wine_cellar':
      return PiWineFill;
    case 'garden':
      return MdYard;
    case 'commute_friendly':
      return MdCommute;
    case 'high_ceiling':
      return FaPeopleRoof;
    case 'sauna':
      return GiCampfire;
    case 'roof_terrace':
      return MdRoofing;
    case 'freehold_plot':
      return MdLandscape;
    case 'scenic_nature_area':
      return MdLandscape;
    default:
      return MdBalcony;
  }
};

export const getNearbyButtonIcon = (key: NearbyType) => {
  switch (key) {
    case 'bakery':
      return GiSlicedBread;
    case 'cafe':
      return MdCoffee;
    case 'deli':
      return TbCheese;
    // case 'airport':
    //   return FaPlane;
    case 'supermarket':
      return FaShoppingCart;
    case 'park':
      return MdPark;
    case 'kindergarten':
      return FaBabyCarriage;
    case 'school':
      return GiOpenBook;
    case 'college':
      return IoSchool;
    case 'university':
      return RiSchoolFill;
    case 'fitness_centre':
      return CgGym;
    case 'fitness_station':
      return FaRunning;
    case 'hairdresser':
      return HiScissors;
    case 'dry_cleaning':
      return MdDryCleaning;
    case 'marina':
      return MdSailing;
    case 'playground':
      return FaChild;
    case 'kiosk':
      return BsNewspaper;
    case 'massage':
      return TbMassage;
    case 'beauty':
      return FaEye;
    case 'fast_food':
      return MdFastfood;
    case 'pitch':
      return MdSportsTennis;
    case 'sports_centre':
      return MdSportsBasketball;
    case 'golf_course':
      return MdGolfCourse;
    case 'slipway':
      return BiWater;
    case 'stadium':
      return FaFootballBall;
    case 'bus_station':
      return FaSubway;
    case 'railway_station':
      return FaSubway;
    case 'ferry_terminal':
      return IoMdBoat;
    case 'restaurant':
      return GiKnifeFork;
    case 'convenience':
      return FaShoppingBasket;
    case 'pub':
      return FaBeer;
    case 'dentist':
      return TbDental;
    case 'clinic':
      return BiClinic;
    // case 'cinema':
    //   return FaVideo;
    // case 'hospital':
    //   return FaHospital;
    case 'pharmacy':
      return FaClinicMedical;
    case 'agrarian':
      return FaShop;
    case 'place_of_worship':
      return FaChurch;
    case 'public_bath':
      return TbSwimming;
    default:
      return MdBalcony;
  }
};
export const getPersonaButtonIcon = (key: PersonaType) => {
  switch (key) {
    case 'family':
      return MdOutlineFamilyRestroom;
    case 'couple':
      return GiLovers;
    case 'single':
      return ImUser;
    case 'student':
      return PiStudentFill;
    case 'singleParent':
      return GiAges;
    case 'young':
      return GiPartyHat;
    case 'elderly':
      return MdElderly;
    default:
      return ImUser;
  }
};
